import { FC } from 'react'
import { PropsWithChildren } from 'react'
import { useLocation } from 'react-router-dom'

type Props = {
  blockedPath?: Array<string>
  allowedPath?: Array<string>
}

const URLPathControl: FC<PropsWithChildren<Props>> = ({ children, allowedPath, blockedPath }) => {
  const { pathname } = useLocation()

  if (allowedPath && allowedPath.some((path) => pathname.includes(path))) {
    return <>{children}</>
  }

  if (blockedPath && !blockedPath.some((path) => pathname.includes(path))) {
    return <>{children}</>
  }

  return null
}

export { URLPathControl }
